import {Injectable} from '@angular/core';
import {
    Address,
    sortAddresses,
    toAddress
} from '../classes/Address';
import {Observable} from 'rxjs/observable';
import {map} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {RestAddressService} from "./restService/restAddressService";


@Injectable({
    providedIn: 'root'
})
export class AddressService {
    private static readonly noAddressSubject: BehaviorSubject<Address[]> = new BehaviorSubject<Address[]>(null);

    constructor(private restAddressService: RestAddressService) {
    }

    public searchAddress(addressSearch: any, requireEastingNorthing: boolean = false): Observable<Address[]> {
        if (!addressSearch) {
            return AddressService.noAddressSubject.asObservable();
        }
        return this.GetAddresses(addressSearch, requireEastingNorthing);
    }

    public GetAddresses = (searchValue: string, requireEastingNorthing: boolean = false): Observable<Address[]> => {
        const result = this.restAddressService.getList(searchValue, requireEastingNorthing);
        return result.pipe(
            map(addresses => addresses.map(a => toAddress(a))),
            map(addresses => addresses.sort(sortAddresses))
        );
    }
}